import React from 'react';
import TicketListFunctional from './components/ticket-list-functional';
import './style.scss'

const TicketList = () => {
	return <TicketListFunctional />;
};

export default TicketList;
